import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { format, addDays } from "date-fns";
import { Button } from "react-bootstrap";
import Modal from "react-modal";
import { fetchGymData } from "../../data/APIs";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import DateRanger from "../components-react/DateRanger";
import TrainerDetailsAdmin from "./trainer-details/TrainerDetailsAdmin";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import SelectDropdown from "../components-react/SelectDropdown";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

const GlobalGymFilterAndHeading = ({
  decryptedText,
  selectedGym,
  setSelectedGym,
  startAndEndDate,
  setStartAndEndDate,
  isPageHeadingHide,
}) => {
  const dispatch = useDispatch();

  const gymData = useSelector(selectGymData);
  const isAdmin = decryptedText?.account_type === "admin";
  const isManagerRole = checkIsManagerRole(decryptedText);

  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [allTDModal, setAllTDModal] = useState(false);

  const handleDateRangeChange = (item, name) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    const formattedStart = moment(formattedStartDate)
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");
    const formattedEnd = moment(formattedEndDate)
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");

    setStartAndEndDate({
      ...startAndEndDate,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      selectedDates: `${formattedStart} - ${formattedEnd}`,
    });
  };

  const selectedGymQueryParam =
    (isAdmin || isManagerRole) && selectedGym?.value
      ? `&gym_id=${selectedGym.value}`
      : !isAdmin && !isManagerRole
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : "";
  const queryParametersForAll = `${selectedGymQueryParam}`;

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, []);

  return (
    <div className="mainContainer">
      <div className="innerContainer">
        <Modal
          isOpen={allTDModal}
          onRequestClose={() => setAllTDModal(false)}
          contentLabel="Assigned Member"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer incentiveHostoryModalContainer">
            <ModalHeadAndClose title="" onClose={() => setAllTDModal(false)} />

            <TrainerDetailsAdmin
              gymId={selectedGymQueryParam}
              queryParametersForAll={queryParametersForAll}
            />
          </div>
        </Modal>

        <div className="globalGymANdDatesFilterContainer ptFlow">
          <div className="ptHeading">
            {!isPageHeadingHide && (
              <h1 className="heading">Personal training</h1>
            )}
          </div>
          <div className="innerGlobalGymANdDatesFilterContainer lastFlex">
            {(isAdmin || isManagerRole) && (
              <div className="commonWrapper width80Per minWidth500px borderRdius64px">
                <SelectDropdown
                  options={gymData}
                  selectedOption={selectedGym}
                  setSelectedOption={(selectedValue) =>
                    setSelectedGym(selectedValue)
                  }
                  name="Gym"
                />
              </div>
            )}

            <div className="commonWrapper dateCommonWrapper width230Per borderRdius64px">
              {dateRangerOpen ? (
                <div className="closeAndClearDateRangerButtons">
                  <Button
                    variant="primary"
                    className="borderRdius64px"
                    onClick={() => setDateRangerOpen(false)}
                  >
                    Close
                  </Button>
                  <Button
                    variant="danger"
                    className="borderRdius64px"
                    onClick={() => {
                      setDateRangerOpen(false);
                      setRangeState(initialRangeState);
                      setStartAndEndDate((prevs) => ({
                        ...prevs,
                        startDate: "",
                        endDate: "",
                        selectedDates: null,
                      }));
                    }}
                  >
                    Clear
                  </Button>
                </div>
              ) : startAndEndDate?.selectedDates ? (
                <Button
                  onClick={() => {
                    setDateRangerOpen(true);
                  }}
                  className="btn-k btn-primary-k large borderRdius64px"
                  variant="danger"
                >
                  {startAndEndDate.selectedDates}
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setDateRangerOpen(true);
                  }}
                  className="btn-k btn-primary-k large borderRdius64px"
                  variant="danger"
                >
                  Select Date
                </Button>
              )}
            </div>

            {dateRangerOpen && (
              <div className="openedDateRanger dateCommonWrapper">
                <DateRanger
                  handleDateRangeChange={handleDateRangeChange}
                  rangeState={rangeState}
                  onClose={() => setDateRangerOpen(false)}
                  onClear={() => {
                    setDateRangerOpen(false);
                    setRangeState(initialRangeState);
                    setStartAndEndDate((prevs) => ({
                      ...prevs,
                      startDate: "",
                      endDate: "",
                      selectedDates: null,
                    }));
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalGymFilterAndHeading;
